import { RequestStatus } from "mobx-store";

export interface IDeglawyFeaturedStore {
  delawyFeaturesList: DeglawyFeatured[];
  selectedDelawyFeatured: DeglawyFeatured;
  loading: boolean;
  getDeglawyFeaturedRequestStatus: RequestStatus;

  getDelawyFeatures(langCode?: string): Promise<void>;

  getDelawyFeaturedById(id: number, langCode?: string): Promise<void> ;

  createDelawyFeatured(newDelawyFeatured: DeglawyFeatured, langCode?: string): Promise<void>;

  updateDelawyFeatured(updatedDelawyFeatured: DeglawyFeatured, id: number, langCode?: string): Promise<void>;

  updateDelawyFeaturedStatus(updatedDelawyFeaturedStatus: boolean, index: number): Promise<void>;
}

export class DeglawyFeatured {
  id: number;

  isActive: boolean;

  points: number;

  title: string;

  preview: string;

  description: string;

  constructor() {
    this.id = 0;
    this.points = 0;
    this.isActive = false;
    this.title = '';
    this.preview = '';
    this.description = '';
  }

  setId(id: number): void {
    this.id = id;
  }

  getId(): number {
    return this.id;
  }

  setPoints(points: number): void {
    this.points = points;
  }

  getPoints(): number {
    return this.points;
  }

  setIsActive(status: boolean): void {
    this.isActive = status;
  }

  getIsActive(): boolean {
    return this.isActive;
  }

  getTitle(): string {
    return this.title;
  }

  setTitle(title: string): void {
    this.title = title;
  }

  getPreview(): string {
    return this.preview;
  }

  setPreview(preview: string): void {
    this.preview = preview;
  }

  getDescription(): string {
    return this.description;
  }

  setDescription(description: string): void {
    this.description = description;
  }

  getFeatured(): { id: number; isActive: boolean; points: number; title: string; preview: string; description: string } {
    return {
      id: this.id,
      isActive: this.isActive,
      points: this.points,
      title: this.title,
      preview: this.preview,
      description: this.description,
    };
  }

  getFeaturedExceptIdAndIsActive(): { points: number; title: string; preview: string; description: string } {
    return {
      points: this.points,
      title: this.title,
      preview: this.preview,
      description: this.description,
    };
  }
}
